// extracted by mini-css-extract-plugin
export default {"container":"styles_container__PtmGn","content":"styles_content__nSX3R","subtitle":"styles_subtitle__wV--j"};